import GeneralErrorLayout from "./layout/GeneralErrorLayout";

type GlobalErrorProps = {
  error: any;
};

const GlobalError = ({ error }: GlobalErrorProps) => {
  return (
    <GeneralErrorLayout>
      <p>Something went wrong:</p>
      <p>{error.message}</p>
    </GeneralErrorLayout>
  );
};

export default GlobalError;
